import { v4 as uuidv4 } from 'uuid';
import { CLIENT_ACTION, GET_FUNDING_SOURCE } from './constants';
import { renderClientName } from 'utils';

export const signatureDetailReport = () => {
    return {
        title: 'Signature Report',
        url: '/reports/appt/signature/pdf',
        filterClients: true,
        list: [
            {
                required: true,
                type: 'select',
                name: 'payer',
                label: 'Payer',
                loadType: GET_FUNDING_SOURCE,
                renderValue: (option) => option?.name,
            },
            {
                type: 'selectWidthPagination',
                name: 'client',
                label: 'Client',
                reqType: 'client',
                renderValue: (option) => renderClientName(option),
            },
            // {
            //     // required: true,
            //     type: 'select',
            //     name: 'client',
            //     label: 'Client',
            //     loadType: CLIENT_ACTION,
            //     renderValue: (option) => renderClientName(option),
            // },
            {
                type: 'monthDate',
                name: 'date',
                startLabel: 'Date',
                required: true,
            },
        ],
    };
};

export const reportWithoutSignature = () => {
    return {
        title: 'Report Without Signature',
        url: '/reports/appt/signature-detail/pdf',
        filterClients: true,
        list: [
            {
                required: true,
                type: 'select',
                name: 'payer',
                label: 'Payer',
                loadType: GET_FUNDING_SOURCE,
                renderValue: (option) => option?.name,
            },
            {
                type: 'selectWidthPagination',
                name: 'client',
                label: 'Client',
                reqType: 'client',
                renderValue: (option) => renderClientName(option),
            },
            {
                type: 'monthDate',
                name: 'date',
                startLabel: 'Date',
                required: true,
            },
        ],
    };
};

export const signatureReportEnums = [
    {
        id: uuidv4(),
        name: 'Signature Report',
        description: 'List of Signatures.',
        generateInfo: signatureDetailReport(),
    },
    {
        id: uuidv4(),
        name: 'Report Without Signature',
        description: 'No signature image included. For internal or draft use.',
        generateInfo: reportWithoutSignature(),
    },
];
